import Vue from 'vue'
import axios from 'axios'

let isLoading = false // 加载提示是否在显示中

const axiosInstance = (config) => {
  const instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL
  })
  instance.interceptors.request.use((req) => {
    if (!isLoading && config.showLoading) {
      Vue.prototype.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      isLoading = true
    }
    return req
  })

  instance.interceptors.response.use((res) => {
    if (isLoading && config.showLoading) {
      Vue.prototype.$toast.clear()
      isLoading = true
    }
    isLoading = false
    return res.data
  })

  return instance(config)
}

export default axiosInstance
